import { getUserSession } from "../../core/util/core/Session"

export const chooseProfileFilter = () => {
    const session = getUserSession()

    const { loggedUserInfo } = session
    const objectToReturn = {};
    if (loggedUserInfo.governance_room_department_id) {
        objectToReturn.governance_room_department_id = loggedUserInfo.governance_room_department_id;
    }
    if (loggedUserInfo.governance_room_secretariat_id) {
        objectToReturn.governance_room_secretariat_id = loggedUserInfo.governance_room_secretariat_id;
    }
    if (loggedUserInfo.governance_room_client_city_id) {
        objectToReturn.governance_room_client_city_id = loggedUserInfo.governance_room_client_city_id;
    }
    if (loggedUserInfo.application_instance_id) {
        objectToReturn.core_application_instance_id = loggedUserInfo.application_instance_id;
    }
    return objectToReturn;
}